export default __webpack_public_path__ + "static/media/Mask of Unsettled Minds.ae79b16c.jpg";